import type { AnyAction } from "redux";
import {
    TOGGLE_QUALIFICATION_SIDE_BAR,
    SET_QUALIFICATION_SIDE_BAR_SELECTION,
} from "app/action_types/qualification_side_bar_action_types";
import type { QualificationSideBarSelectionType } from "app/components/QualificationSideBar/types";

interface IQualificationSideBarReducer {
    /**
     * Indicates whether the qualififcation side bar is opened or not
     */
    isQualificationSideBarOpened: boolean;

    /**
     * Indicates which site data to display in qualififcation side bar
     */
    qualificationSideBarSelection: QualificationSideBarSelectionType | null;
}

function getDefaultState(): IQualificationSideBarReducer {
    return {
        isQualificationSideBarOpened: false,
        qualificationSideBarSelection: null,
    };
}

function qualificationSideBar(state: IQualificationSideBarReducer = getDefaultState(), action: AnyAction) {
    switch (action.type) {
        case TOGGLE_QUALIFICATION_SIDE_BAR:
            return {
                ...state,
                isQualificationSideBarOpened: action.isQualificationSideBarOpened,
            };

        case SET_QUALIFICATION_SIDE_BAR_SELECTION:
            return {
                ...state,
                qualificationSideBarSelection: action.qualificationSideBarSelection,
            };

        default:
            return state;
    }
}

export default qualificationSideBar;
